import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Fragment from 'react-dot-fragment';
import { Draggable, DragComponent, Droppable } from 'react-dragtastic';
import { Loader } from 'react-loaders';
import { getRequest, postRequest } from '../../../api/ApiService';

import GripIcon from '../../../containers/assets/onboarding-grip.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Items = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 24px;
  gap: 20px;
`;

const Item = styled.div`
  display: flex;
  width: 210px;
  height: 208px;
  background: #ffffff;
  border: 1px solid #d5d9dd;
  border-radius: 12px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 36px;
`;

const ItemCaption = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  padding-top: 36px;
`;

const ItemZone = styled.div`
  width: 178px;
  height: 96px;
  background: #ffffff;
  border: 1.5px dashed rgba(0, 27, 59, 0.6);
  border-radius: 8px;
  align-items: center;
  justify-content: center;
  display: flex;

  ${p => p.isDropped && `
    background: rgba(0, 27, 59, 0.08);
  `}
`;

const Options = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 24px;
  gap: 16px;
`;

const Option = styled.div`
  display: block;
  padding: 12px 20px 12px 24px;
  background: #ffffff;
  border: 1px solid #d5d9dd;
  border-radius: 8px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 6px 4px rgba(0, 0, 0, 0.08);

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.94);
  cursor: pointer;
  position: relative;

  ${p => p.isHidden && `
    opacity: 0;
  `}

  ${p => p.isDropped && `
    box-shadow: none;
    display: inline-block;
    cursor: default;
    font-size: 14px;
    line-height: 14px;
  `}

  img {
    position: absolute;
    top: 10px;
    left: 4px;
  }
`;

class TriviaFormula1 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      val1: null,
      val2: null,
      val3: null,
      isReadOnly: false,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { data } = this.props;
    const { userId, questionId, triviaId } = data;

    this.props.setMode('disabled');

    this.props.setFetchData(true);
    getRequest(`${process.env.REACT_APP_API_URL}v2/trivia/triviaresponses/`)
      .then(res => {
        const answer = res.body.results.find(i => (
          i.user === userId
          && i.trivia_question === questionId
          && i.course_trivia === triviaId
        ));
        const isReadOnly = !!answer;
        const val1Choice = answer ? answer.pickedoptions.find(i => i.order === 1) : null;
        const val1 = val1Choice ? val1Choice.option_choice : null;
        const val2Choice = answer ? answer.pickedoptions.find(i => i.order === 2) : null;
        const val2 = val2Choice ? val2Choice.option_choice : null;
        const val3Choice = answer ? answer.pickedoptions.find(i => i.order === 3) : null;
        const val3 = val3Choice ? val3Choice.option_choice : null;

        if (isReadOnly) {
          this.props.setMode('basic');
        }

        this.props.setFetchData(false);
        this.setState({
          isReadOnly,
          val1,
          val2,
          val3,
        });
      })
      .catch(err => {});
  }

  componentDidUpdate(prevProps) {
    if (this.props.data.num !== prevProps.data.num) {
      this.setState({
        val1: null,
        val2: null,
        val3: null,
        isReadOnly: false,
      }, () => {
        this.fetchData();
      });
    }
  }

  onDrop1 = val => {
    this.setState({
      val1: val,
    }, () => {
      this.prevalidate();
    });
  }

  onDropOut1 = () => {
    this.setState({
      val1: null,
    }, () => {
      this.prevalidate();
    });
  }

  onDrop2 = val => {
    this.setState({
      val2: val,
    }, () => {
      this.prevalidate();
    });
  }

  onDropOut2 = () => {
    this.setState({
      val2: null,
    }, () => {
      this.prevalidate();
    });
  }

  onDrop3 = val => {
    this.setState({
      val3: val,
    }, () => {
      this.prevalidate();
    });
  }

  onDropOut3 = () => {
    this.setState({
      val3: null,
    }, () => {
      this.prevalidate();
    });
  }

  prevalidate = () => {
    const { val1, val2, val3 } = this.state;

    if (!!val1 && !!val2 && !!val3) {
      this.props.setMode('validate', this.validate);
    } else {
      this.props.setMode('disabled');
    }
  }

  validate = () => {
    const { data } = this.props;
    const { val1, val2, val3 } = this.state;
    const { userId, questionId, triviaId } = data;

    this.props.setMode('loading');
    postRequest(`${process.env.REACT_APP_API_URL}v2/trivia/triviaresponses/`)
      .send({
        user: userId,
        trivia_question: questionId,
        course_trivia: triviaId,
        pickedoptions: [
          { option_choice: val1, order: 1 },
          { option_choice: val2, order: 2 },
          { option_choice: val3, order: 3 },
        ],
      })
      .then(res => {
        if (res.body.is_correct === 'Yes') {
          this.props.showConfetti();
        } else {
          this.props.showIncorrectMessage();
        }

        this.setState({
          isReadOnly: true,
        });

        this.props.setMode('basic');
      })
      .catch(err => {
        this.props.setMode('basic');
      });
  }

  render() {
    const { val1, val2, val3, isReadOnly } = this.state;
    const { data, stage, isFetchData } = this.props;
    const { num, text, choices, captions } = data;

    let val1Text = null;
    if (val1) {
      const val1Obj = choices.find(i => i.id === val1);
      val1Text = val1Obj ? val1Obj.text : null;
    }

    let val2Text = null;
    if (val2) {
      const val2Obj = choices.find(i => i.id === val2);
      val2Text = val2Obj ? val2Obj.text : null;
    }

    let val3Text = null;
    if (val3) {
      const val3Obj = choices.find(i => i.id === val3);
      val3Text = val3Obj ? val3Obj.text : null;
    }

    return isFetchData ? (
      <Wrapper>
        <Loader type="ball-scale-ripple" active />
      </Wrapper>
    ) : (
      <Wrapper>
        <Text1>Trivia: {stage === 'welcome' ? 'Warm Up' : `Round ${stage}`}</Text1>
        <Text2>{num}. {text}</Text2>
        <Items>
          <Item>
            <ItemCaption>{captions[0]}</ItemCaption>
            <Droppable
              id="formula1"
              accepts="formula"
              onDrop={this.onDrop1}
              onDragLeave={this.onDropOut1}
            >
              {({ events, isOver }) => (
                <ItemZone
                  {...events}
                  isDropped={isOver || !!val1}
                >
                  {val1 && isReadOnly && (
                    <Option isDropped={true}>
                      <img src={GripIcon} alt="" />
                      {val1Text}
                    </Option>
                  )}
                  {val1 && !isReadOnly && (
                    <Draggable
                      id={`choice-${val1}`}
                      type="formula"
                      data={val1}
                    >
                      {({ isActive, events }) => (
                        <Option {...events} isDropped={true} isHidden={isActive}>
                          <img src={GripIcon} alt="" />
                          {val1Text}
                        </Option>
                      )}
                    </Draggable>
                  )}
                </ItemZone>
              )}
            </Droppable>
          </Item>
          <Item>
            <ItemCaption>{captions[1]}</ItemCaption>
            <Droppable
              id="formula2"
              accepts="formula"
              onDrop={this.onDrop2}
              onDragLeave={this.onDropOut2}
            >
              {({ events, isOver }) => (
                <ItemZone
                  {...events}
                  isDropped={isOver || !!val2}
                >
                  {val2 && isReadOnly && (
                    <Option isDropped={true}>
                      <img src={GripIcon} alt="" />
                      {val2Text}
                    </Option>
                  )}
                  {val2 && !isReadOnly && (
                    <Draggable
                      id={`choice-${val2}`}
                      type="formula"
                      data={val2}
                    >
                      {({ isActive, events }) => (
                        <Option {...events} isDropped={true} isHidden={isActive}>
                          <img src={GripIcon} alt="" />
                          {val2Text}
                        </Option>
                      )}
                    </Draggable>
                  )}
                </ItemZone>
              )}
            </Droppable>
          </Item>
          <Item>
            <ItemCaption>{captions[2]}</ItemCaption>
            <Droppable
              id="formula3"
              accepts="formula"
              onDrop={this.onDrop3}
              onDragLeave={this.onDropOut3}
            >
              {({ events, isOver }) => (
                <ItemZone
                  {...events}
                  isDropped={isOver || !!val3}
                >
                  {val3 && isReadOnly && (
                    <Option isDropped={true}>
                      <img src={GripIcon} alt="" />
                      {val3Text}
                    </Option>
                  )}
                  {val3 && !isReadOnly && (
                    <Draggable
                      id={`choice-${val3}`}
                      type="formula"
                      data={val3}
                    >
                      {({ isActive, events }) => (
                        <Option {...events} isDropped={true} isHidden={isActive}>
                          <img src={GripIcon} alt="" />
                          {val3Text}
                        </Option>
                      )}
                    </Draggable>
                  )}
                </ItemZone>
              )}
            </Droppable>
          </Item>
        </Items>
        {!isReadOnly && (
          <Options>
            {choices.map(choice => (
              <Fragment key={`choice-fragment-${choice.id}`}>
                <Draggable
                  id={`choice-${choice.id}`}
                  type="formula"
                  data={choice.id}
                >
                  {({ isActive, events }) => (
                    <Option {...events} isHidden={isActive || val1 === choice.id || val2 === choice.id || val3 === choice.id}>
                      <img src={GripIcon} alt="" />
                      {choice.text}
                    </Option>
                  )}
                </Draggable>
                <DragComponent for={`choice-${choice.id}`}>
                  {({ x, y }) => (
                    <Option style={{
                      position: 'fixed',
                      left: x - 20,
                      top: y - 21,
                      pointerEvents: 'none',
                      zIndex: 2,
                    }}>
                      <img src={GripIcon} alt="" />
                      {choice.text}
                    </Option>
                  )}
                </DragComponent>
              </Fragment>
            ))}
          </Options>
        )}
      </Wrapper>
    );
  }

}

export default TriviaFormula1;



// WEBPACK FOOTER //
// ./src/components/onboarding/trivia/Formula1.js